import { Component, OnInit, ViewChild } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { showErrorMessage, testHtmlRegex } from '../../helpers/helpers';

@Component({
  selector: 'app-dropdown-wrapper',
  templateUrl: './dropdown-wrapper.component.html',
  styleUrls: ['./dropdown-wrapper.component.scss']
})
export class DropdownWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild("form") elementView: any;
  isHtml: boolean = false;
  isMarginRequired: boolean = true;
  isWidthRequired: boolean = false;
  showErrMessage = showErrorMessage;
  
  ngOnInit(): void {
    this.isHtml = testHtmlRegex(this.props.description);
  }

  ngAfterViewInit() {
    if (this.elementView?._elementRef?.nativeElement?.offsetWidth > 800) {
      this.isWidthRequired = true;
    }
  }
}
